<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay vistas del documento que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    El documento aún no ha sido visto por ningún usuario
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>cargando datos de tabla...</strong>
                </div>
            </template>

        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';

export default {
    name: 'DocumentVisitorTable',

    components: {
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],

            fields: [
                {
                    key: 'dateSeen',
                    label: 'Fecha de última vista documento',
                    formatter: (value) => {
                        return this.formatDate(value);
                    }
                },
                { key: 'mail', label: 'Correo del usuario' }
            ]
        }
    },

    props: {
        documentId: {
            type: String
        }
    },

    async mounted() {
        await this.getAllVisitor();
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar aqui

            return filtered;
        }
    },

    methods: {
        ...mapActions(["getAllVisitorForDocumentId"]),

        onRowSelected(items) {
            this.selected = items;
        },

        processingTable() {
            this.isBusy = !this.isBusy
        },

        async getAllVisitor() {
            this.processingTable();
            let result = await this.getAllVisitorForDocumentId({ documentId: this.documentId });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.processingTable();
                return;
            }

            this.items = result.data;
            this.processingTable();
        },
        formatDate(date) {
            if (date == null) {
                return;
            }

            // Crear un objeto Date con la fecha y hora ISO
            var fechaHora = new Date(date);

            // Formatear la fecha y hora en un formato legible para el usuario
            var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
        },

    }

}
</script>
<style></style>
